<template>
  <transition name="drag-upload-overlay-fade">
    <div
      v-if="visible"
      class="drag-upload-overlay"
      @dragenter.prevent.stop
      @dragleave.prevent.stop="handleDragLeave"
      @dragover.prevent.stop
      @drop.prevent.stop="handleDrop"
    >
      <div class="drag-upload-overlay__panel">
        <i class="drag-upload-overlay__icon icon-drag-line t-iconfont"></i>
        <div class="drag-upload-overlay__content">
          <div class="drag-upload-overlay__title">拖拽到此处上传文件</div>
          <div class="drag-upload-overlay__tip">
            支持 {{ acceptText }} 格式，总文件大小上限为 {{ maxSize }}MB
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  acceptText: {
    type: String,
    default: 'PDF / DOC / DOCX / MD / PNG / JPG / JPEG'
  },
  maxSize: {
    type: [Number, String],
    default: 1
  }
})

const emits = defineEmits(['drop-files', 'drag-leave'])

const handleDragLeave = (event) => {
  emits('drag-leave', event)
}

const handleDrop = (event) => {
  emits('drop-files', event.dataTransfer?.files)
}
</script>

<style lang="scss" scoped>
.drag-upload-overlay {
  position: absolute;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 24px;
  background: linear-gradient(304deg, #f7f5ff33 1%, #f3f7ff33 100%);
  backdrop-filter: blur(40px);
}

.drag-upload-overlay__panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: 1px dashed #969799;
  border-radius: 24px;
  pointer-events: none;
}

.drag-upload-overlay__icon {
  margin-bottom: 16px;
  color: #323233;
  font-size: 32px;
  line-height: 32px;
}

.drag-upload-overlay__content {
  width: 100%;
  text-align: center;
}

.drag-upload-overlay__title {
  color: #323233;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.drag-upload-overlay__tip {
  margin-top: 4px;
  color: #969799;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.drag-upload-overlay-fade-enter-active,
.drag-upload-overlay-fade-leave-active {
  transition: opacity 0.16s ease;
}

.drag-upload-overlay-fade-enter-from,
.drag-upload-overlay-fade-leave-to {
  opacity: 0;
}
</style>
